import { render, staticRenderFns } from "./PatientOverview.vue?vue&type=template&id=7d293165&"
import script from "./PatientOverview.vue?vue&type=script&lang=js&"
export * from "./PatientOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports